// src/features/counterSlice.js
import { createSlice } from "@reduxjs/toolkit"

// const initialState = { viewCatalogModalLiveChat: false }
const initialState = {
  membershipPlan: {

  },
  livechatData: {
    viewCatalogModalLiveChatData: {
      modalView: false,
      productList: []
    },
    showRecievedContactsData:{
      modalView: false,
      contactList: []
    }
  }
}

export const whatsappSlice = createSlice({
  name: "whatsappSlice",
  initialState,
  reducers: {
    setViewCatalogModalLiveChat: (state, action) => {
      state.livechatData.viewCatalogModalLiveChatData.modalView = action.payload
    },
    setLivechatCatalogModalProducts: (state, action) => {
      state.livechatData.viewCatalogModalLiveChatData.productList = action.payload
    },
    setLivechatRecievedData: (state, action) => {
      state.livechatData.showRecievedContactsData = {...state.livechatData.showRecievedContactsData, ...action.payload}
    },
    setWaMembershipPlan: (state, action) => {
      state.membershipPlan = action.payload
    }
  }
})

export const { setViewCatalogModalLiveChat, setLivechatCatalogModalProducts, setWaMembershipPlan, setLivechatRecievedData } = whatsappSlice.actions

export default whatsappSlice.reducer
